// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyCTdefVY1S7rLbMaphpJjk0chwJgzm4HDc',
  authDomain: 'speedbox-2.firebaseapp.com',
  databaseURL: 'https://speedbox-2.firebaseio.com',
  projectId: 'speedbox-2',
  storageBucket: 'speedbox-2.firebasestorage.app',
  messagingSenderId: '734219558819',
  appId: '1:734219558819:web:3b0b403d25c4bdc94bc416',
  measurementId: 'G-KLDT074KTE',
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, onMessage, getToken };
